import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { IntelligentScreenDefaultValueService } from './intelligent-screen/intelligent-screen-default-value.service';
import { ActiveProtectionSystemDefaultValueService } from './active-protection-system/active-protection-system-default-value.service';
import { IntelligentSecuritySettingsDefaultValueService } from './intelligent-security-settings/intelligent-security-settings-value.service';

@Injectable({
	providedIn: 'root'
})
export class SmartAssistDefaultValueService {
	constructor(
		private activeProtectionSystemDefaultValueService: ActiveProtectionSystemDefaultValueService,
		private intelligentScreenDefaultValueService: IntelligentScreenDefaultValueService,
		private intelligentSecuritySettingsDefaultValueService: IntelligentSecuritySettingsDefaultValueService,
	) { }

	public initialize(adTags: any) {
		this.activeProtectionSystemDefaultValueService.initialize(adTags);
		this.intelligentScreenDefaultValueService.initialize(adTags);
		this.intelligentSecuritySettingsDefaultValueService.initialize(adTags);
	}
}
